module.exports = __webpack_public_path__ + "static/media/System.25ed98fa.svg";